import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { getManagerProfileOptions } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { Checkbox, CHECKBOX_SIZE, CHECKBOX_TYPE } from '../../../../Checkbox'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer, FormFieldSelectNG } from '../../../../Form'
import {
  FormikEntityActionConfigFields,
  FormikField,
  getFormikCheckboxFieldValueProps,
  getFormikFormFieldErrorProps,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../../Formik'
import {
  SelectDropdownListFooter,
  SelectDropdownListHeader,
} from '../../../../Select'
import {
  toUserSelectItemsFromOption,
  USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL,
  UserMultiSelect,
} from '../../../../User'
import {
  BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER,
  BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS,
  EDIT_MANAGERS_FORM_INITIAL_VALUES,
} from '../BuildingGroupsEditManagersActionModal.constants'

import * as styles from './FormFields.module.css'

function FormFields({ actionTypes }) {
  const { t } = useTranslation()

  const { errors, setFieldValue, values } = useFormikContext()

  useEffect(() => {
    if (values[BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER].length === 0) {
      setFieldValue(
        BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS,
        false
      )
    }
  }, [values[BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER]])

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: EDIT_MANAGERS_FORM_INITIAL_VALUES,
    })

  const disabledCheckbox =
    values[BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER].length === 0 &&
    !actionTypeValueIsRemoveAll

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: errors[BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER],
          options: actionTypes,
        }}
      >
        <FormikField
          multi
          Component={FormFieldSelectNG}
          Field={FieldStackedLabel}
          Select={UserMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                placeholder: t('BuildingGroup.EditManagersFieldPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          dropdownFloatingConfig={
            USER_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL
          }
          emptyValue={EMPTY_LIST}
          fieldComponentProps={{
            label: `${t('BuildingGroup.EditManagersFieldLabelKey')}`,
          }}
          getData={getManagerProfileOptions}
          getDataItems={getItemsFromIdwellApiResponse}
          getErrorProps={getFormikFormFieldErrorProps}
          listProps={{
            Footer: SelectDropdownListFooter,
            Header: SelectDropdownListHeader,
          }}
          name={BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_MANAGER}
          toPreparedItems={toUserSelectItemsFromOption}
        />
        <FormikField
          Component={Checkbox}
          disabled={disabledCheckbox}
          getErrorProps={getFormikFormFieldErrorProps}
          getValueProps={getFormikCheckboxFieldValueProps}
          label={t('BuildingGroup.UpdateManagersFieldLabelKey')}
          labelClassName={styles.checkboxLabel}
          labelTitleClassName={styles.checkboxLabelTitle}
          name={BUILDING_GROUP_EDIT_MANAGERS_FIELD_NAME_UPDATE_MANAGERS}
          size={CHECKBOX_SIZE.small}
          type={CHECKBOX_TYPE.action}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
